import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M11 4a4.25 4.25 0 1 0 0 8.5A4.25 4.25 0 0 0 11 4ZM8.25 8.25a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z" />
    <path d="M11.05 1a7.15 7.15 0 0 0-6.47 3.97 7.42 7.42 0 0 0 .25 7.18l5 8.19a1.37 1.37 0 0 0 2.34 0l5-8.19A7.4 7.4 0 0 0 14.82 2.1 7.15 7.15 0 0 0 11.05 1Zm-3 2.34a5.65 5.65 0 0 1 8.07 2.38 5.92 5.92 0 0 1-.24 5.65l-4.88 8-4.88-8a5.9 5.9 0 0 1 1.92-8.03Z" />
  </svg>
);
